import { Box, Stack, Text, Loader, ThemeIcon, Center } from "@mantine/core";
import { IconCheck, IconCircleXFilled } from "@tabler/icons-react";

const steps = [
  { label: "In Progress", description: "simulation is in progress" },
  { label: "Completed", description: "Simulation Completed" },
];

const ICON_SIZE = 32;

const StatusIcon = ({ status }) => {
  if (status === "done") {
    return (
      <ThemeIcon radius="xl" color="green" size={ICON_SIZE}>
        <IconCheck size={18} />
      </ThemeIcon>
    );
  }

  if (status === "active") {
    return <Loader size={ICON_SIZE} color="blue" />;
  }

  if (status === "error") {
    return (
      <ThemeIcon radius="xl" color="red" size={ICON_SIZE}>
        <IconCircleXFilled size={18} />
      </ThemeIcon>
    );
  }

  return (
    <Box
      w={ICON_SIZE}
      h={ICON_SIZE}
      style={{
        borderRadius: "50%",
        border: "5px solid #d9d9d9",
        boxSizing: "border-box",
      }}
    />
  );
};

const OrderTrackingVertical = ({ currentStatus }) => {
  const activeStep = steps.findIndex(
    (step) =>
      step.label.toLowerCase() ===
      currentStatus?.toLowerCase()?.replace(" (error)", "")
  );

  const isError = currentStatus?.toLowerCase().includes("error");

  const getStepStatus = (index) => {
    if (isError && index === activeStep) return "error";
    if (index < activeStep) return "done";
    if (index === activeStep)
      return index === steps.length - 1 ? "done" : "active";
    return "pending";
  };

  return (
    <Center>
      <Stack spacing={ICON_SIZE} align="flex-start" pos="relative">
        {steps.map((step, index) => {
          const status = getStepStatus(index);

          return (
            <Box
              key={index}
              style={{
                display: "flex",
                position: "relative",
                gap: 12,
                alignItems: "center",
              }}
            >
              {index < steps.length - 1 && (
                <Box
                  style={{
                    position: "absolute",
                    top: ICON_SIZE - 1,
                    left: ICON_SIZE / 2,
                    width: 2,
                    height: ICON_SIZE * 1.1,
                    backgroundColor:
                      getStepStatus(index + 1) === "done" ||
                      getStepStatus(index + 1) === "active"
                        ? "#3dcd58"
                        : "#ccc",
                    transform: "translateX(-50%)",
                    zIndex: 0,
                  }}
                />
              )}

              <Box style={{ zIndex: 1, minWidth: ICON_SIZE }}>
                <StatusIcon status={status} />
              </Box>
              <Box>
                <Text fw={500}>{step.label}</Text>
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Center>
  );
};

export default OrderTrackingVertical;
